import { useState } from 'react';
const INIT_TABS_ERRORS_COUNT = [0, 0];

const useCustomHook = () => {
  const [loading, setLoading] = useState(false);
  const [, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [dedicatedActivation, setDedicatedActivation] = useState(null);
  const [businessCallBackUri, setBusinessCallBackUri] = useState(null);
  const [subscriptionType, setSubscriptionType] = useState(null);
  const [consumeType, setConsumeType] = useState('DISPOSABLE_ITEM'); // "DISPOSABLE_ITEM" or "DISPOSABLE_INVOICE" or "UNLIMITED"
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedGuilds, setSelectedGuilds] = useState([]);
  const [selectedBusinesses, setSelectedBusinesses] = useState([]);
  const [stakeholderList, setStakeholderList] = useState([]);
  const [productId, setProductId] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [fetching, setFetching] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [beneficiary, setBeneficiary] = useState(null);
  const [noLimitSelected, setNoLimitSelected] = useState(false); // check error on limit option, one or both of them should be selected
  const [tabsErrors, setTabsErrors] = useState(INIT_TABS_ERRORS_COUNT);
  const [guildsList, setGuildsList] = useState([]);
  const [guildListLoading, setGuildListLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [page, setPage] = useState(0);

  const [openDialog, setOpenDialog] = useState(false);
  const [indexSelected, setIndexSelected] = useState(-1);
  const [mySharePercent, setMySharePercent] = useState(0);
  const [enterPercent, setEnterPercent] = useState(true);
  const [useOfpercentage, setUseOfpercentage] = useState(false);
  const [comparativeAccountList, setComparativeAccountList] = useState({
    list: [],
    selectedList: [],
  });


  const [open, setOpen] = useState(false);
  const [days, setDays] = useState(null); // زمان باقیمانده
  const [count, setCount] = useState(null); // میزان مصرف
  const [countPercent, setCountPercent] = useState(null); // درصد دفعات استفاده شده
  const [amountPercent, setAmountPercent] = useState(null);
  const [data, setData] = useState(null);

  const [loadingTable, setloadingTable] = useState(false);
  return {
    data, setData,
    loadingTable, setloadingTable,
    open, setOpen,
    days, setDays,
    count, setCount,
    countPercent, setCountPercent,
    amountPercent, setAmountPercent,
    loadingBtn, setLoadingBtn,
    openDialog, setOpenDialog,
    page, setPage,
    indexSelected, setIndexSelected,
    mySharePercent, setMySharePercent,
    enterPercent, setEnterPercent,
    useOfpercentage, setUseOfpercentage,
    comparativeAccountList, setComparativeAccountList,


    guildsList,
    setGuildsList,
    guildListLoading,
    setGuildListLoading,
    activeStep,
    setActiveStep,
    noLimitSelected,
    setNoLimitSelected,
    tabsErrors,
    setTabsErrors,
    fetching,
    setFetching,
    productId,
    setProductId,
    beneficiary,
    setBeneficiary,
    isConfirmOpen,
    setIsConfirmOpen,
    consumeType,
    setConsumeType,
    selectedProducts,
    setSelectedProducts,
    selectedGuilds,
    setSelectedGuilds,
    selectedBusinesses,
    setSelectedBusinesses,
    stakeholderList,
    setStakeholderList,

    setFilterParams,
    loading,
    setLoading,
    dedicatedActivation,
    setDedicatedActivation,
    size,
    setSize,
    businessCallBackUri,
    setBusinessCallBackUri,
    subscriptionType,
    setSubscriptionType,
  };
};

export default useCustomHook;
